import React, { Component } from "react";
import { connect } from "react-redux";
import { css } from "aphrodite";
import CardDokterSubspesialis from
  "../../components/dasboard/CardDokterSubspesialis";
import CardPertumbuhanOrtho from
  "../../components/dasboard/CardPertumbuhanOrtho";
import CardPPDS from "../../components/dasboard/CardPPDS";
import CardPenerimaanPPDS from
  "../../components/dasboard/CardPenerimaanPPDS";
import {
  listSubspecialist,
  listCandidate,
  listGraduated,
  listOrthopaedi,
} from "../../actions/dashboard/kolegium_action";
import { getDashboardData } from
  "../../reducers/dashboard/kolegium_reducer";
import { dashboardGridStyles as s } from
  "../../components/dasboard/dashboardGridStyles";

class DashboardAdminPusat extends Component {
  render() {
    return (
      <>
        <div className={css(s.row)}>
          <div className={css(s.col60)}>
            <div style={{
              backgroundColor: "#FFC156",
              height: 10,
              width: "100%",
            }} />
            <CardPenerimaanPPDS />
            <div style={{
              backgroundColor: "#00A4ED",
              height: 10,
              width: "100%",
            }} />
            <CardPertumbuhanOrtho />
          </div>
          <div className={css(s.col40)}>
            <CardDokterSubspesialis />
          </div>
        </div>
        <div className={css(s.row)}>
          <div className={css(s.col100)}>
            <div style={{
              backgroundColor: "#5AB853",
              height: 10,
              width: "100%",
            }} />
            <CardPPDS />
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({
  listCandidate,
  listGraduated,
  listOrthopaedi,
  listSubspecialist,
}) {
  return {
    listCandidate_data: getDashboardData(listCandidate),
    listGraduated_data: getDashboardData(listGraduated),
    listOrthopaedi_data: getDashboardData(listOrthopaedi),
  };
}

export default connect(mapStateToProps, {
  listSubspecialist,
  listCandidate,
  listGraduated,
  listOrthopaedi,
})(DashboardAdminPusat);
